import styled from 'styled-components';

import background from './assets/background.png';
import info from './assets/info.png';
import logo from './assets/logo.png';

export const Wrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: url('${background}');
  background-position-x: center;
  background-size: cover;
`;

export const Logo = styled.div`
  position: absolute;
  left: 48px;
  top: 48px;
  height: 40px;
  width: 236px;
  background: url('${logo}');
  background-position-x: center;
  background-size: cover;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 96px;
    height: 204px;
    width: 294px;
    background: url('${info}');
    background-position-x: center;
    background-size: cover;
  }

  @media (max-width: 1440px) {
    left: 32px;
  }

  @media (max-width: 1280px) {
    left: 0;

    &::after {
      left: 6px;
      height: 160px;
      width: 234px;
    }
  }
`;
